import { Injectable } from '@angular/core';
import {
  Validators,
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import startWithALetter from './start-with-a-letter';
import cannotContainNumbers from './cannot-contain-numbers';
import invalidMonth from './invalid-month';
import invalidDayForMonth from './invalid-day-for-month';
import atLeast18YearsOld from './at-least-18-years-old';
import atLeastAge from './at-least-age';
import atMostAge from './at-most-age';
import missingCharacter from './missing-character';
import invalidCharacter from './invalid-character';
import maxCharacterCount from './max-character-count';
import mod10 from './mod-10';
import maxAmount from './max-amount';
import minAmount from './min-amount';
import { mmYYFuture } from './mm-yy-future';
import bankRouting from './bank-routing';
import phoneOrEmail from './phone-or-email';
import mustBeOneOf from './must-be-one-of';

export type ValidatorGetter = (args: any[]) => ValidatorFn;

@Injectable({
  providedIn: 'root',
})
export class ValidationService {
  constructor() {}

  getValidatorByKey(
    validatorName: string,
    errorKeyOverride?: string,
    args?: any[]
  ) {
    const validatorGetter = _validatorLookup[validatorName];
    if (!validatorGetter) {
      // throw??
    }
    let argsCopy = [];
    if (args) {
      argsCopy = [...args];
    }
    return control => {
      const result = validatorGetter(argsCopy)(control);
      if (result && errorKeyOverride) {
        return {
          [errorKeyOverride]: true,
        };
      } else {
        return result;
      }
    };
  }

  registerValidator(key: string, validatorGetter: ValidatorGetter) {
    _validatorLookup[key] = validatorGetter;
  }

  getValidatorList() {
    return Object.keys(_validatorLookup).map(vlkp => {
      return {
        key: vlkp,
        validator: _validatorLookup[vlkp],
      };
    });
  }
}

const _validatorLookup: { [key: string]: ValidatorGetter } = {
  required: () => Validators.required,
  minlength: args => Validators.minLength(args[0]),
  maxlength: args => Validators.maxLength(args[0]),
  pattern: args => Validators.pattern(args[0]),
  requiredTrue: () => Validators.requiredTrue,
  numeric: () => numeric,
  alphaNumeric: () => alphaNumeric,
  startWithALetter: () => startWithALetter,
  cannotContainNumbers: () => cannotContainNumbers,
  invalidMonth: () => invalidMonth,
  invalidDayForMonth: () => invalidDayForMonth,
  atLeast18YearsOld: () => atLeast18YearsOld,
  atLeastAge: args => atLeastAge(args[0]),
  atMostAge: args => atMostAge(args[0]),
  missingCharacter: args => missingCharacter(args[0]),
  invalidCharacter: args => invalidCharacter(args[0]),
  maxCharacterCount: args => maxCharacterCount(args[0], args[1]),
  mod10: () => mod10,
  maxAmount: args => maxAmount(args[0]),
  minAmount: args => minAmount(args[0]),
  mmYYFuture: () => mmYYFuture,
  bankRouting: () => bankRouting,
  phoneOrEmail: () => phoneOrEmail,
  mustBeOneOf: args => mustBeOneOf(args[0]),
};

// Custom validators
export function numeric(control: AbstractControl): ValidationErrors {
  return _testRegex(control, /^\d+$/, 'numeric');
}

export function alphaNumeric(control: AbstractControl): ValidationErrors {
  return _testRegex(control, /^(\d|\w)+$/, 'alphaNumeric');
}

export function _testRegex(
  control: AbstractControl,
  pattern: RegExp,
  error: any
) {
  if (control && control.value) {
    const value = control.value;
    const regex = pattern;
    if (!regex.test(value)) {
      return {
        [error]: true,
      };
    }
  }
  return null;
}
